import { create } from 'zustand';

const useDialogStore = create((set) => ({
  current: null,

  confirm: (title, message = '', options = {}) => new Promise((resolve) => {
    set({
      current: {
        type: 'confirm',
        title,
        message,
        confirmLabel: options.confirmLabel || 'Confirmar',
        cancelLabel: options.cancelLabel || 'Cancelar',
        danger: !!options.danger,
        resolve,
      },
    });
  }),

  prompt: (title, options = {}) => new Promise((resolve) => {
    set({
      current: {
        type: 'prompt',
        title,
        message: options.message || '',
        label: options.label || '',
        defaultValue: options.defaultValue || '',
        inputType: options.inputType || 'text',
        placeholder: options.placeholder || '',
        confirmLabel: options.confirmLabel || 'OK',
        cancelLabel: options.cancelLabel || 'Cancelar',
        minLength: options.minLength || 0,
        resolve,
      },
    });
  }),

  alert: (title, message = '', options = {}) => new Promise((resolve) => {
    set({
      current: {
        type: 'alert',
        title,
        message,
        confirmLabel: options.confirmLabel || 'OK',
        danger: !!options.danger,
        resolve,
      },
    });
  }),

  resolveCurrent: (value) => {
    set((s) => {
      s.current?.resolve?.(value);
      return { current: null };
    });
  },
}));

export const dialog = {
  confirm: (title, message, options) => useDialogStore.getState().confirm(title, message, options),
  prompt: (title, options) => useDialogStore.getState().prompt(title, options),
  alert: (title, message, options) => useDialogStore.getState().alert(title, message, options),
};

export default useDialogStore;
